import getErrorMessage from "../utils/getErrorMessage";

let attempts = 0;

// Reset max errors every second.
if (process.browser)
  setInterval(() => {
    attempts = 0;
  }, 1000);

const Toast = (ctx, next) => {
  const { req, res, locals, flash } = ctx;

  return next().catch((err) => {
    const alternative = ctx.isLoggedIn() ? "/dashboard" : "/logout";

    if (process.browser) attempts++;
    try {
      console.error(err.stack || err);
    } catch (_) {
      console.log(err);
    }
    if (attempts <= 5 && err.code) {
      flash("error", getErrorMessage(err));
    } else {
      flash("error", "Could not load page, please try again later");
    }

    res.backDontScroll(alternative);
  });
};

export default Toast;
